import {
  DashboardResponse,
  StatusResponse,
  PositionsResponse,
  PnlResponse,
  TodayResponse,
  WeekResponse,
  TradesResponse,
  BuyHistoryResponse,
  SellHistoryResponse,
  RiskResponse,
  HealthResponse,
  SignalsResponse,
  OrdersResponse,
  SettingsResponse,
  AuthMeResponse,
  ResetCircuitBreakerResponse,
} from '@/types/api';
import { Position, Trade, Order, Signal } from '@/types/trading';

export const mockPositions: Position[] = [
  {
    id: 'pos-1',
    symbol: 'TATAMOTORS',
    exchange: 'NSE',
    quantity: 75,
    entry_price: 980.5,
    ltp: 1012.3,
    unrealized_pnl: 2385.0,
    unrealized_pnl_percent: 3.24,
    stop_loss: 940.0,
    take_profit: 1060.0,
    status: 'OPEN',
    holding_duration: '2d 4h',
    opened_at: new Date(Date.now() - 187200000).toISOString(),
    updated_at: new Date().toISOString(),
  },
  {
    id: 'pos-2',
    symbol: 'RELIANCE',
    exchange: 'NSE',
    quantity: 30,
    entry_price: 2950.0,
    ltp: 2915.2,
    unrealized_pnl: -1044.0,
    unrealized_pnl_percent: -1.18,
    stop_loss: 2860.0,
    take_profit: 3120.0,
    status: 'OPEN',
    holding_duration: '1d 6h',
    opened_at: new Date(Date.now() - 108000000).toISOString(),
    updated_at: new Date().toISOString(),
  },
  {
    id: 'pos-3',
    symbol: 'INFY',
    exchange: 'NSE',
    quantity: 50,
    entry_price: 1890.0,
    // Intentionally testing null LTP when fresh market cycle has not arrived
    ltp: null,
    unrealized_pnl: null,
    unrealized_pnl_percent: null,
    stop_loss: 1820.0,
    take_profit: 2020.0,
    status: 'OPEN',
    holding_duration: '45m',
    opened_at: new Date(Date.now() - 2700000).toISOString(),
    updated_at: new Date().toISOString(),
  },
];

export const mockTrades: Trade[] = [
  {
    id: 'tr-1',
    timestamp: new Date(Date.now() - 3600000).toISOString(),
    symbol: 'HDFCBANK',
    side: 'SELL',
    quantity: 40,
    price: 1680.0,
    order_type: 'MARKET',
    status: 'COMPLETED',
    pnl: 1420.0,
    pnl_percent: 2.16,
    reason: 'Take Profit Target Reached',
  },
  {
    id: 'tr-2',
    timestamp: new Date(Date.now() - 14400000).toISOString(),
    symbol: 'ICICIBANK',
    side: 'BUY',
    quantity: 60,
    price: 1240.5,
    order_type: 'MARKET',
    status: 'COMPLETED',
    pnl: null,
    pnl_percent: null,
    reason: 'Telegram Channel Bullish Breakout Signal',
  },
  {
    id: 'tr-3',
    timestamp: new Date(Date.now() - 86400000).toISOString(),
    symbol: 'BAJFINANCE',
    side: 'SELL',
    quantity: 15,
    price: 7150.0,
    order_type: 'MARKET',
    status: 'COMPLETED',
    pnl: -850.0,
    pnl_percent: -0.79,
    reason: 'Stop Loss Hit (Risk Boundary)',
  },
  {
    id: 'tr-4',
    timestamp: new Date(Date.now() - 172800000).toISOString(),
    symbol: 'SBIN',
    side: 'SELL',
    quantity: 100,
    price: 825.0,
    order_type: 'MARKET',
    status: 'COMPLETED',
    pnl: 3200.0,
    pnl_percent: 4.04,
    reason: 'Trailing Stop Triggered at High',
  },
];

export const mockOrders: Order[] = [
  {
    id: 'ord-101',
    order_id: 'BO-20260918-001',
    symbol: 'INFY',
    side: 'BUY',
    quantity: 50,
    price: 1890.0,
    order_type: 'MARKET',
    status: 'FILLED',
    timestamp: new Date(Date.now() - 2700000).toISOString(),
    rejection_reason: null,
    signal_id: 1,
    mode: 'PAPER',
  },
  {
    id: 'ord-102',
    order_id: 'BO-20260918-002',
    symbol: 'HDFCBANK',
    side: 'SELL',
    quantity: 40,
    price: 1680.0,
    order_type: 'MARKET',
    status: 'FILLED',
    timestamp: new Date(Date.now() - 3600000).toISOString(),
    rejection_reason: null,
    signal_id: null,
    mode: 'PAPER',
  },
  {
    id: 'ord-103',
    order_id: 'BO-20260918-003',
    symbol: 'TCS',
    side: 'BUY',
    quantity: 20,
    price: 4320.0,
    order_type: 'LIMIT',
    status: 'REJECTED',
    timestamp: new Date(Date.now() - 21600000).toISOString(),
    rejection_reason: 'Max daily position capacity (5) reached',
    signal_id: null,
    mode: 'PAPER',
  },
  {
    id: 'ord-105',
    order_id: 'BO-20260918-005',
    symbol: 'TATAMOTORS',
    side: 'BUY',
    quantity: 75,
    price: 980.5,
    order_type: 'MARKET',
    status: 'REJECTED',
    timestamp: new Date(Date.now() - 28800000).toISOString(),
    rejection_reason: 'Broker RMS margin shortfall',
    signal_id: 5,
    mode: 'PAPER',
  },
];

export const mockSignals: Signal[] = [
  {
    id: '1',
    raw_id: 1,
    raw_message: 'BUY INFY CMP 1890 SL 1820 TGT 2020 SWING SETUP',
    parsed_symbol: 'INFY',
    timestamp: new Date(Date.now() - 2800000).toISOString(),
    signal_type: 'BUY',
    validation_status: 'POSITION_OPENED',
    status: 'POSITION_OPENED',
    rejection_reason: null,
    outcome_reason_code: null,
    outcome_reason: null,
    risk_decision_at: new Date(Date.now() - 2795000).toISOString(),
    order_attempted: true,
    order_id: 'BO-20260918-001',
    position_id: 'pos-3',
    execution_status: 'FILLED',
    updated_at: new Date(Date.now() - 2700000).toISOString(),
    execution_state: 'POSITION_OPENED',
    price: 1890.0,
    source_chat_id: '-1001234567890',
    source_message_id: '101',
  },
  {
    id: '2',
    raw_id: 2,
    raw_message: 'BUY TCS CMP 4320 SL 4150 TGT 4600',
    parsed_symbol: 'TCS',
    timestamp: new Date(Date.now() - 21700000).toISOString(),
    signal_type: 'BUY',
    validation_status: 'BLOCKED_RISK',
    status: 'BLOCKED_RISK',
    rejection_reason: 'Max open positions limit reached (3/3 allowed by risk manager)',
    outcome_reason_code: 'MAX_OPEN_POSITIONS_REACHED',
    outcome_reason: 'Max open positions limit reached (3/3 allowed by risk manager)',
    risk_decision_at: new Date(Date.now() - 21695000).toISOString(),
    order_attempted: false,
    order_id: null,
    position_id: null,
    execution_status: null,
    updated_at: new Date(Date.now() - 21695000).toISOString(),
    execution_state: 'BLOCKED_RISK',
    price: 4320.0,
    source_chat_id: '-1001234567890',
    source_message_id: '102',
  },
  {
    id: '3',
    raw_id: 3,
    raw_message: 'BUY INVALIDXYZ CMP 100',
    parsed_symbol: 'INVALIDXYZ',
    timestamp: new Date(Date.now() - 43200000).toISOString(),
    signal_type: 'BUY',
    validation_status: 'REJECTED',
    status: 'REJECTED',
    rejection_reason: 'Symbol not found in NSE master symbol registry',
    outcome_reason_code: 'INVALID_SYMBOL',
    outcome_reason: 'Symbol not found in NSE master symbol registry',
    risk_decision_at: null,
    order_attempted: false,
    order_id: null,
    position_id: null,
    execution_status: null,
    updated_at: new Date(Date.now() - 43200000).toISOString(),
    execution_state: 'REJECTED',
    price: 100.0,
    source_chat_id: '-1001234567890',
    source_message_id: '103',
  },
  {
    id: '4',
    raw_id: 4,
    raw_message: 'BUY RELIANCE CMP 2950 SL 2860 TGT 3120',
    parsed_symbol: 'RELIANCE',
    timestamp: new Date(Date.now() - 50000).toISOString(),
    signal_type: 'BUY',
    validation_status: 'RECEIVED',
    status: 'RECEIVED',
    rejection_reason: null,
    outcome_reason_code: null,
    outcome_reason: null,
    risk_decision_at: null,
    order_attempted: false,
    order_id: null,
    position_id: null,
    execution_status: null,
    updated_at: new Date(Date.now() - 50000).toISOString(),
    execution_state: 'RECEIVED',
    price: 2950.0,
    source_chat_id: '-1001234567890',
    source_message_id: '104',
  },
  {
    id: '5',
    raw_id: 5,
    raw_message: 'BUY TATAMOTORS CMP 980 SL 940 TGT 1060',
    parsed_symbol: 'TATAMOTORS',
    timestamp: new Date(Date.now() - 28900000).toISOString(),
    signal_type: 'BUY',
    validation_status: 'ORDER_REJECTED',
    status: 'ORDER_REJECTED',
    rejection_reason: 'Broker rejected order: RMS margin shortfall',
    outcome_reason_code: 'BROKER_REJECTED',
    outcome_reason: 'Broker rejected order: RMS margin shortfall',
    risk_decision_at: new Date(Date.now() - 28895000).toISOString(),
    order_attempted: true,
    order_id: 'BO-20260918-005',
    position_id: null,
    execution_status: 'REJECTED',
    updated_at: new Date(Date.now() - 28800000).toISOString(),
    execution_state: 'ORDER_REJECTED',
    price: 980.5,
    source_chat_id: '-1001234567890',
    source_message_id: '105',
  },
  {
    id: '6',
    raw_id: 6,
    raw_message: 'BUY SBIN CMP 825 SL 795 TGT 880',
    parsed_symbol: 'SBIN',
    timestamp: new Date(Date.now() - 32000000).toISOString(),
    signal_type: 'BUY',
    validation_status: 'ORDER_FAILED',
    status: 'ORDER_FAILED',
    rejection_reason: 'Broker API timeout during order placement',
    outcome_reason_code: 'ORDER_SUBMISSION_FAILED',
    outcome_reason: 'Broker API timeout during order placement',
    risk_decision_at: new Date(Date.now() - 31995000).toISOString(),
    order_attempted: true,
    order_id: null,
    position_id: null,
    execution_status: 'FAILED',
    updated_at: new Date(Date.now() - 31990000).toISOString(),
    execution_state: 'ORDER_FAILED',
    price: 825.0,
    source_chat_id: '-1001234567890',
    source_message_id: '106',
  },
  {
    id: '7',
    raw_id: 7,
    raw_message: 'BUY HDFCBANK CMP 1680 SL 1620 TGT 1780',
    parsed_symbol: 'HDFCBANK',
    timestamp: new Date(Date.now() - 36000000).toISOString(),
    signal_type: 'BUY',
    validation_status: 'EXECUTION_UNKNOWN',
    status: 'EXECUTION_UNKNOWN',
    rejection_reason: 'Order placed but confirmation unverified in broker reconciliation cycle',
    outcome_reason_code: 'EXECUTION_DISCREPANCY',
    outcome_reason: 'Order placed but confirmation unverified in broker reconciliation cycle',
    risk_decision_at: new Date(Date.now() - 35995000).toISOString(),
    order_attempted: true,
    order_id: 'BO-20260918-007',
    position_id: null,
    execution_status: 'UNKNOWN',
    updated_at: new Date(Date.now() - 35990000).toISOString(),
    execution_state: 'EXECUTION_UNKNOWN',
    price: 1680.0,
    source_chat_id: '-1001234567890',
    source_message_id: '107',
  },
  {
    id: '8',
    raw_id: 8,
    raw_message: null,
    parsed_symbol: 'WIPRO',
    timestamp: null,
    signal_type: null,
    validation_status: 'PROCESSED',
    status: 'PROCESSED',
    rejection_reason: null,
    outcome_reason_code: null,
    outcome_reason: 'Legacy exit signal processed',
    risk_decision_at: null,
    order_attempted: false,
    order_id: null,
    position_id: null,
    execution_status: null,
    updated_at: null,
    execution_state: 'PROCESSED',
    price: null,
    source_chat_id: null,
    source_message_id: null,
  },
];

export const mockDashboardData: DashboardResponse = {
  bot_status: {
    status: 'RUNNING',
    mode: 'PAPER',
    market_status: 'OPEN',
    uptime: '4d 14h 22m',
    last_cycle: new Date(Date.now() - 45000).toISOString(),
    last_signal: new Date(Date.now() - 2800000).toISOString(),
    broker_connected: true,
  },
  pnl_summary: {
    today_pnl: 1420.0,
    unrealized_pnl: 1341.0,
    realized_pnl: 1420.0,
    weekly_pnl: 5770.0,
    total_pnl: 18450.0,
    win_rate: 75.0,
    total_trades: 8,
    winning_trades: 6,
    losing_trades: 2,
    average_win: 1850.0,
    average_loss: -780.0,
    profit_factor: 2.37,
    circuit_breaker_halted: false,
  },
  positions_summary: {
    open_positions_count: 3,
    max_positions: 5,
    available_capacity: 2,
  },
  risk_summary: {
    trading_allowed: true,
    kill_switch_active: false,
    daily_loss: 0,
    daily_loss_limit: 5000.0,
    trades_today: 2,
    max_trades_per_day: 6,
    consecutive_losses: 0,
    max_consecutive_losses: 3,
    circuit_breaker_triggered: false,
    circuit_breaker_halted: false,
    permission_reason: null,
  },
  recent_trades: mockTrades.slice(0, 5),
  recent_signals: mockSignals.slice(0, 5),
};

export const mockStatusData: StatusResponse = {
  status: 'RUNNING',
  mode: 'PAPER',
  market_status: 'OPEN',
  uptime: '4d 14h 22m',
  uptime_seconds: 397320,
  last_cycle: new Date(Date.now() - 45000).toISOString(),
  last_signal: new Date(Date.now() - 2800000).toISOString(),
  broker_connected: true,
  timestamp: new Date().toISOString(),
};

export const mockPositionsData: PositionsResponse = {
  positions: mockPositions,
  total_open: mockPositions.length,
  max_positions: 5,
  available_capacity: 2,
};

export const mockPnlData: PnlResponse = {
  summary: mockDashboardData.pnl_summary,
  daily_history: [
    { date: 'Mon', pnl: 1200, realized_pnl: 1200, trades_count: 2 },
    { date: 'Tue', pnl: 2400, realized_pnl: 2400, trades_count: 3 },
    { date: 'Wed', pnl: -850, realized_pnl: -850, trades_count: 1 },
    { date: 'Thu', pnl: 1600, realized_pnl: 1600, trades_count: 2 },
    { date: 'Fri (Today)', pnl: 1420, realized_pnl: 1420, trades_count: 1 },
  ],
};

export const mockTodayData: TodayResponse = {
  today_pnl: 1420.0,
  realized_pnl: 1420.0,
  unrealized_pnl: 1341.0,
  trades_count: 1,
  winning_trades: 1,
  losing_trades: 0,
  win_rate: 100.0,
  trades: [mockTrades[0]],
};

export const mockWeekData: WeekResponse = {
  weekly_pnl: 5770.0,
  trades_count: 9,
  win_rate: 77.8,
  days: mockPnlData.daily_history || [],
};

export const mockTradesData: TradesResponse = {
  trades: mockTrades,
  total_count: mockTrades.length,
};

export const mockBuyHistoryData: BuyHistoryResponse = {
  buy_orders: mockTrades.filter((t) => t.side === 'BUY'),
  total_count: mockTrades.filter((t) => t.side === 'BUY').length,
};

export const mockSellHistoryData: SellHistoryResponse = {
  sell_orders: mockTrades.filter((t) => t.side === 'SELL'),
  total_count: mockTrades.filter((t) => t.side === 'SELL').length,
};

export const mockRiskData: RiskResponse = {
  risk: mockDashboardData.risk_summary,
  timestamp: new Date().toISOString(),
};

export const mockHealthData: HealthResponse = {
  health: {
    status: 'HEALTHY',
    last_successful_order_check: new Date(Date.now() - 30000).toISOString(),
    last_reconciliation: new Date(Date.now() - 120000).toISOString(),
    last_cycle: new Date(Date.now() - 45000).toISOString(),
    last_signal: new Date(Date.now() - 2800000).toISOString(),
    database_status: 'CONNECTED (SQLite WAL)',
    uptime_seconds: 397320,
    memory_usage_mb: 48.6,
  },
  timestamp: new Date().toISOString(),
};

export const mockSignalsData: SignalsResponse = {
  signals: mockSignals,
  total_count: mockSignals.length,
};

export const mockOrdersData: OrdersResponse = {
  orders: mockOrders,
  total_count: mockOrders.length,
};

export const mockAuthMeData: AuthMeResponse = {
  authenticated: true,
  username: 'admin',
  expires_at: new Date(Date.now() + 7 * 24 * 3600 * 1000).toISOString(),
};

export const mockSettingsData: SettingsResponse = {
  version: 1,
  updated_at: new Date().toISOString(),
  settings: {
    TRADING_ENABLED: {
      value: true,
      type: 'bool',
      unit: 'boolean',
      category: 'trading',
      description: 'Master trading switch for new entries',
      editable: true,
      affects_existing_positions: false,
    },
    CAPITAL_PER_TRADE: {
      value: 10000.0,
      type: 'float',
      unit: 'INR',
      category: 'trading',
      description: 'Capital allocated per trade in INR',
      editable: true,
      affects_existing_positions: false,
      min: 1000.0,
      max: 500000.0,
    },
    MAX_OPEN_POSITIONS: {
      value: 2,
      type: 'int',
      unit: 'count',
      category: 'trading',
      description: 'Maximum concurrent open positions',
      editable: true,
      affects_existing_positions: false,
      min: 1,
      max: 10,
    },
    MAX_TRADES_PER_DAY: {
      value: 10,
      type: 'int',
      unit: 'count',
      category: 'trading',
      description: 'Maximum completed trades allowed per day',
      editable: true,
      affects_existing_positions: false,
      min: 1,
      max: 50,
    },
    MAX_DAILY_LOSS: {
      value: 2000.0,
      type: 'float',
      unit: 'INR',
      category: 'risk',
      description: 'Daily circuit breaker loss limit in INR',
      editable: true,
      affects_existing_positions: false,
      min: 100.0,
      max: 50000.0,
    },
    MAX_CONSECUTIVE_LOSSES: {
      value: 3,
      type: 'int',
      unit: 'count',
      category: 'risk',
      description: 'Consecutive losses before halting trading',
      editable: true,
      affects_existing_positions: false,
      min: 1,
      max: 10,
    },
    STOP_LOSS_PCT: {
      value: 2.0,
      type: 'float',
      unit: 'percent',
      category: 'risk',
      description: 'Stop loss percentage for new entries',
      editable: true,
      affects_existing_positions: false,
      min: 0.25,
      max: 10.0,
    },
    TAKE_PROFIT_PCT: {
      value: 3.0,
      type: 'float',
      unit: 'percent',
      category: 'risk',
      description: 'Take profit percentage for new entries',
      editable: true,
      affects_existing_positions: false,
      min: 0.5,
      max: 25.0,
    },
    TIME_BASED_EXIT_ENABLED: {
      value: true,
      type: 'bool',
      unit: 'boolean',
      category: 'exit',
      description: 'Enable or disable time-based force exits',
      editable: true,
      affects_existing_positions: true,
    },
    MAX_HOLDING_TIME_MINUTES: {
      value: 120,
      type: 'int',
      unit: 'minutes',
      category: 'exit',
      description: 'Maximum holding time in minutes before force exit',
      editable: true,
      affects_existing_positions: true,
      min: 15,
      max: 1440,
    },
  },
};

export const mockResetCircuitBreakerData: ResetCircuitBreakerResponse = {
  success: true,
  reset_performed: true,
  message: 'Circuit breaker successfully reset',
  previous_halted: true,
  current_halted: false,
  daily_stats: {
    trading_date: new Date().toISOString().split('T')[0],
    trade_count: 2,
    realized_pnl: 1420.0,
    consecutive_losses: 0,
    trading_halted: 0,
  },
  applicable_limits: {
    max_trades_per_day: 6,
    max_daily_loss: 5000.0,
    max_consecutive_losses: 3,
  },
};
